import type { CommunityDetail } from '@pba/react-network';
import { HeaderWrapper } from 'layouts';
import { useTranslation } from 'react-i18next';
import { usePermissions } from 'permissions';
import { Card, HeaderAsset, HeaderContent, Icon } from 'ui';
import type { CommunityTabItem } from '../types';
import { CommunityJoinedStatus } from './community-joined-status';
import { CommunityTabs } from './community-tabs';
import { useActions } from './hooks';

export type P = {
  activeTab: CommunityTabItem;
  community: CommunityDetail;
  isPublicView: boolean;
  onNavigateToCommunityTab: (tab: CommunityTabItem) => void;
};

const CommunityHeader = ({ activeTab, community, isPublicView, onNavigateToCommunityTab }: P) => {
  const { t } = useTranslation();
  const { hasMembershipInCommunity } = usePermissions();
  const isMemberInCommunity = hasMembershipInCommunity({ communityId: community.id });
  const { actions } = useActions({ community });

  return (
    <>
      {/* TODO: Will be used in Task #87927 for Community modals */}
      <HeaderWrapper
        left={<HeaderAsset image={{ alt: t('Community cover photo'), src: community.coverPhoto?.url }} />}
        right={
          <HeaderContent
            actions={actions}
            extra={isMemberInCommunity ? <CommunityJoinedStatus community={community} /> : null}
            membersCount={community.membersCount}
            tags={{ children: 'Community', color: 'green', icon: <Icon icon="classify-2-line" /> }}
            title={community.name}
          />
        }
      />
      {isMemberInCommunity || isPublicView ? (
        <Card shrinked>
          <CommunityTabs
            active={activeTab}
            isPublicView={isPublicView}
            onNavigateToCommunityTab={onNavigateToCommunityTab}
          />
        </Card>
      ) : null}
    </>
  );
};

export default CommunityHeader;
